// extracted by mini-css-extract-plugin
export default {"title":"title___bLDNz","cardItem":"cardItem___WPXP9","label":"label___mO3Uf","cardItem_disable":"cardItem_disable___pyz3b","add":"add___j46TW"};